export default {
  closeButton: 'Close',
  retryButton: 'Retry',
};
